import React from "react";

import Hero from "../sections/Home/Hero/Hero";
import LatestCompetitions from "../sections/Home/LatestCompetitions/LatestCompetitions";
import FeaturedClubs from "../sections/Home/FeaturedClubs/FeaturedClubs";
import LatestNews from "../sections/Home/LatestNews/LatestNews";
import Features from "../sections/Home/Features/Features";
import CTABanner from "../sections/Home/CTABanner/CTABanner";

export default function Home() {
  return (
    <main className="overflow-hidden">

      <Hero />

      <LatestCompetitions />

      <FeaturedClubs />

      <LatestNews />

      <Features />

      <CTABanner />

    </main>
  );
}